<form class="m-3" novalidate [formGroup]="form" (submit)="checkBuildupService(form.value, true)">
  <div class="row">
    <div class="col-8">
      <p>Gib deine PLZ ein um die Verfügbarkeit unseres Aufbauservice in deiner Region zu prüfen.</p>
    </div>

    <div class="input-group col-8  mt-2">
      <input type="text" class="form-control" formControlName="postalcode" id="postalcodeInput" placeholder="Postleitzahl" (keyup)="checkBuildupService(form.value, false)">
      <button class="btn btn-black" type="submit" id="button-addon"><gea-svg-arrow-right /></button>
    </div>

    <div class="col-8 mt-4">
      @let bs = buildupService();
      @if (!errorMsg()) {
        @if (bs) {
          <p class="success" ><gea-svg-success /> In dieser Region verfügbar.</p>
          <p><b>{{ bs.name }}</b>:&nbsp;{{ bs.price }}&nbsp;€</p>
        }
      } @else {
        <p class="error"><gea-svg-error />  {{ errorMsg() }}</p>
      }

    </div>
  </div>
</form>